module.exports = __webpack_public_path__ + "static/media/madball-details.ee69727b.jpg";